
<b-row class="mt-4 product-tile" no-gutters align-v="center" align-h="center">
  <b-col cols="4" class="m-auto text-center pb-4">
    <b-img
      v-if="localValue.image"
      class="product-image shadow"
      :alt="localValue.title"
      :src="localValue.image"
      :title="localValue.title"
      fluid
      lazy
      width="160"
      height="160"
      @click="viewing = localValue"
      @error="handleImageError"
    />
    <div v-else class="image-placeholder product-placeholder">
      <div>{{ imagePlaceholder(localValue.title) }}</div>
    </div>
  </b-col>

  <b-col cols="12" class="product-tile__title">
    {{ localValue.title }}
  </b-col>

  <b-col v-show="showActions" cols="12">
    <div class="my-3">
      <product-modifiers
        :value="localValue.modifiers"
        :validated.sync="modifiersValid"
        @input="updateModifiers"
      />
    </div>

    <b-row v-if="isRegular" align-v="center" align-h="center" no-gutters>
      <b-col cols="12" class="pb-2">
        <b-button-group class="cart-products-btn w-100">
          <b-button
            class="btn col-4"
            @click="removeFromCart(localValue)"
          >
            Remove
          </b-button>
          <b-button
            v-if="!localValue.max_weekly_frequency && !localValue.subscription"
            class="btn-outline"
            @click="subtractProductQty(localValue)"
          >
            <b-icon-dash />
          </b-button>
          <b-button
            v-if="!localValue.max_weekly_frequency && !localValue.subscription"
            class="btn-outline"
            @click="addProductQty(localValue)"
          >
            <b-icon-plus />
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    

    <b-row
      align-v="center"
      align-h="center"
      no-gutters
      class="justify-content-between pt-1"
    >
      <b-col cols="auto">
        <span v-if="isRegular">{{ localValue.quantityOrdered }} x
          <Currency
            primary-font-size="1em"
            secondary-font-size=".8em"
            prepend=""
            :currency="unitPrice"
          />
        </span>
      </b-col>
      <b-col cols="auto" class="font-weight-bold">
        <Currency
          primary-font-size="1rem"
          secondary-font-size=".8em"
          prepend="$"
          :currency="completePrice"
        />
      </b-col>
    </b-row>
  </b-col>

  <product-info v-if="viewing" v-model="viewing" :view-reviews="reviewing" />
  <product-reviews v-if="reviewing" v-model="reviewing" />
</b-row>
